import type { FC } from 'react';
import { useStream } from '@wix/da-shared-react/pkg/utils/hooks/useStream';
import Surface from '@wix/da-ds/pkg/Surface';
import { ThemeSurface } from '@wix/da-react-context/pkg/constants';
import EmptyDiscountList from './EmptyDiscountList';
import DiscountRow from './DiscountRow';
import { SELLER_DISCOUNTS_STREAM } from '../../../../constants';
import OnScrollBottom, {
  DISTANCE_UNIT,
} from '@wix/da-shared-react/pkg/OnScrollBottom';
import { PapiSellerDiscount } from '@wix/da-papi-types';

import s from './SellerDiscounts.scss';

interface Props {}

const SellerDiscounts: FC<Props> = () => {
  const {
    items: discounts,
    isFetching,
    hasMore,
    fetchNext,
  } = useStream(SELLER_DISCOUNTS_STREAM.streamId);

  const isEmpty = discounts.length === 0;

  return (
    <div>
      {!isEmpty && (
        <Surface type={ThemeSurface.SECONDARY} themeOverrideOnly>
          {discounts.map((discount: PapiSellerDiscount) => (
            <DiscountRow
              key={discount.discountId}
              discount={discount}
              className={s['discount-row']}
            />
          ))}
        </Surface>
      )}
      {isEmpty && <EmptyDiscountList />}
      {hasMore && !isFetching ? (
        <OnScrollBottom
          checkOnMount
          checkOnUpdate={hasMore}
          onScrolledToBottom={() => fetchNext()}
          distanceToBottom={100}
          distanceUnit={DISTANCE_UNIT.PX}
        />
      ) : null}
    </div>
  );
};
SellerDiscounts.displayName = 'SellerDiscounts';

export default SellerDiscounts;
